import * as React from 'react'
import { API_URL } from './constants'
import axios from 'axios'

export const CallTSModel = async (request: object) => {
	const path = `${API_URL}/codegen-ts`
	const { data, status } = await axios.post(path, { request })
	return data.result
}
